import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
export default class ChangeBirthdayModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.birthday = Stream(app.session.user.birthday());
  }
  className() {
    return 'ChangeBirthdayModal Modal--small';
  }
  title() {
    return app.translator.trans('datlechin-birthdays.forum.change_dob.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('datlechin-birthdays.forum.change_dob.date_of_birth_text')), m("input", {
      type: "date",
      name: "birthday",
      className: "FormControl",
      bidi: this.birthday,
      disabled: this.loading
    })), m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary',
      type: 'submit',
      loading: this.loading
    }, app.translator.trans('datlechin-birthdays.forum.change_dob.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    if (this.birthday() === app.session.user.birthday() && this.birthday() !== null) {
      this.hide();
      return;
    }
    this.loading = true;
    this.alertAttrs = null;
    app.session.user.save({
      birthday: this.birthday()
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      this.success = true;
      this.hide();
    }).catch(() => {}).then(this.loaded.bind(this));
  }
  onerror(error) {
    super.onerror(error);
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/ChangeBirthdayModal', ChangeBirthdayModal);